import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const PlusIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 8, height = 8, ...props }, ref) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path d="M1 4L7 4M4 7L4 1" stroke="#1677FF" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  },
);
